import $ from 'jquery';
import Cookies from 'js-cookie';
import PauHelpers from './PauHelpers';
import { isMobile } from 'react-device-detect';

class AccesibilityActions {

    /**
     * Navegación
     */

    static donde( checked ) {

        let $pauDonde = $( "#pauDonde" );

        if( checked ) {
            $pauDonde.show();
        } else {
            $pauDonde.hide();
        }

    }

    static bigcursor( checked ) {

        $( "body" ).toggleClass( 'pau-bigcursor', checked );

    }

    static zoomLink( checked ) {

        if( checked ) {

            let style = `
            <style id="pauZoomLink">
                .pauZoomLink {
                   text-decoration: none;
                   display: inline-block;
                   -webkit-transition: all 1s linear;
                   -moz-transition: all 1s linear;
                   -ms-transition: all 1s linear;
                   -o-transition: all 1.4s linear;
                   transition: all 1s linear;
                }

                .pauZoomLink:hover {
                   background: rgba(255, 255, 255, 0.8) !important;
                   color: rgba(0,0,0,1) !important;
                   box-shadow: 10px 10px 10px rgba(152, 152, 152, 0.93) !important;
                   -webkit-transform: scale(1.2,1.5);
                   -moz-transform: scale(1.2,1.5);
                   -ms-transform: scale(1.2,1.5);
                   -o-transform: scale(1.2,1.5);
                   transform: scale(1.2,1.5);
                }
            </style>
            `;

            $( "head" ).append( style );

        } else {

            $( "#pauZoomLink" ).remove();

        }

    }

    /*
     * Fuentes
     */
    static fuentes( type, checked ) {

        switch( type ) {

            case "readable" :
                $( "body" ).toggleClass( 'pau-lecfacil', checked );
                break;

            case "dyslexia" :
                $( "body" ).toggleClass( 'pau_open_dislexia', checked );
                break;

        }

    }

    /*
     * Aumenta el tamaño de la fuente
     */
    static tamanioFuente( tamanio ) {

        let sizes = {
            1   : 1,
            2   : 1.25,
            3   : 1.5,
            4   : 1.75,
            5   : 2,
            6   : 2.25,
            7   : 2.5,
            8   : 2.75,
            9   : 3
        }

        $( "body" ).css( "font-size", sizes[ tamanio ] + "em" );

    }

    /*
     * Reseltar enlaces
     */
    static resaltarEnlaces( checked ) {

        $( "a" )
            .toggleClass( "pau-resaltar", checked )
            .toggleClass( "pau-no-resaltar", ! checked );

    }

    /*
     * Visual
     */
    static visual( type, checked ) {

        switch( type ) {

            case "blackwhite" :
                $( "html" ).toggleClass( 'pau-greyscale', checked );
                break;

            case "invert-colors" :
                $( "html" ).toggleClass( 'pau-accessability-invert', checked );
                break;

        }

    }

    /*
     * Focus
     */
    static focus( checked ) {

        if( checked ) {

            let style = `
            <style id="pauFocusStyle">
                :focus {
                    outline: 5px solid rgba(58, 251, 2, 0.55)!important;
                }
            </style>
            `;

            $( "head" ).append( style );

        } else {

            $( "#pauFocusStyle" ).remove();

        }

    }

    /**
     * Zoom Pau
     */
    static zoomPanel( tamanio ) {

        if( isMobile ) {
            tamanio = parseInt( tamanio, 10 ) - 30;
        }

        let $pauMainAccess = document.getElementById( "pauMainAcces" );

		if( PauHelpers.isFirefox() ) {

            tamanio = tamanio / 100;

            // transform: scale(1.1);
            // transform-origin: 100% 0;

            $pauMainAccess.style.transformOrigin = "100% 0";
			$pauMainAccess.style.transform = `scale( ${tamanio}, ${tamanio} )`;

		} else {

            $pauMainAccess.style.zoom = tamanio + "%";

		}

	}

    static getSettings( key = null ) {

        let settings = Cookies.getJSON( "settings" );

        if( key ) {
            return settings[ key ];
        }

        return settings;

    }

    static initActions({ settings, pauDirUrl = null }) {

        let profDef = Cookies.get('profileDefault');

        if( typeof profDef === "undefined" ) {

            Cookies.remove( "profileDefault", { path : "/" } );
            Cookies.set( "profileDefault", profDef, { path : "/" } );

        }

        /**
         * Navegación
         */

        let pathBigcursor   = `${pauDirUrl}multimedia/pau/react/body/bigcursor.svg`,
            pathBigcursorH  = `${pauDirUrl}multimedia/pau/react/body/bigcursor-hover.svg`,
            styleBigCursor = `
            <style id="pauBigcursorStyle">
                .pau-bigcursor {
                    cursor: url( ${pathBigcursor} ), auto !important;
                }
                .pau-bigcursor a:hover,
                .pau-bigcursor button:hover {
                    cursor: url( ${pathBigcursorH} ), auto !important;
                }
            </style>
            `;

        $( "head" ).append( styleBigCursor );

        // Cursor grande

        AccesibilityActions.bigcursor( settings.nav_bigcursor.value );

        // Donde

        AccesibilityActions.donde( settings.nav_donde.value );

        // Zoom

        $( "a, button" ).addClass( "pauZoomLink" );

        $( "li a" ).removeClass( "pauZoomLink" );

        AccesibilityActions.zoomLink( settings.nav_zoom.value );

        var sonidoClick = document.createElement( 'audio' );

        sonidoClick.src = `${pauDirUrl}multimedia/pau/react/audios/ClickOn.mp3`;

        $( "body" ).prepend( '<div id="pauClickCircle"></div>' );

        $( document ).on( "click", ( e ) => {

            let $pauClickCircle = $( "#pauClickCircle" );

            let setti       = AccesibilityActions.getSettings(),
                { geral_todo, geral_sonido, nav_clic } = setti;

            if( ! geral_todo.value   ) return;
            if( ! geral_sonido.value ) return;
            if( ! nav_clic.value     ) return;

            $pauClickCircle.css({
                display : "block",
                left    : e.clientX - 15,
                top     : e.clientY - 15
            }).fadeOut( 200 );

            sonidoClick.currentTime = 0;
            sonidoClick.play();

        });

        // Fuentes
        AccesibilityActions.fuentes( settings.font_dislexia_legible.value, true );

        AccesibilityActions.tamanioFuente( settings.font_size.value );

        AccesibilityActions.resaltarEnlaces( settings.font_resaltar_links.value );

        // Visual
        AccesibilityActions.visual( settings.visual_colors.value, true );

        AccesibilityActions.focus( settings.visual_resaltar_focus.value );

        // Otros
        AccesibilityActions.zoomPanel( settings.zoom_pau.value );

        let dzoom = document.getElementById( "pauDisplayZoom" );
        dzoom.childNodes[ 0 ].textContent = settings.zoom_pau.value;

    }

}

// const accesMangAct = new AccesibilityActions();

export default AccesibilityActions;



// WEBPACK FOOTER //
// ./src/includes/AccesibilityActions.js